import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import legal from "@/data/legalDocuments.json";

const legalSections = legal.documents.map((document) => ({
  id: document.id,
  title: document.title,
  content: <div className="space-y-3 text-sm leading-relaxed text-muted-foreground">
    <p>Редакция {legal.version}</p>
    <a href={`/legal/${document.slug}.html`} target="_blank" rel="noopener noreferrer" className="underline">Открыть отдельный документ</a>
    <a href={`/legal/${document.slug}.html`} download className="block underline">Скачать документ (.html)</a>
    {document.sections.map((section) => <section key={section.heading} className="space-y-2">
      <h3 className="pt-3 font-medium text-foreground">{section.heading}</h3>
      <p>{section.text}</p>
    </section>)}
  </div>,
}));

interface LegalHubProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  defaultSection?: string;
  trigger?: React.ReactNode;
}

const LegalHub = ({ open, onOpenChange, defaultSection, trigger }: LegalHubProps) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open : internalOpen;
  const setIsOpen = isControlled ? onOpenChange! : setInternalOpen;

  return <Sheet open={isOpen} onOpenChange={setIsOpen}>
    {trigger && <SheetTrigger asChild>{trigger}</SheetTrigger>}
    <SheetContent side="left" className="w-full overflow-y-auto border-border bg-background sm:max-w-lg">
      <SheetHeader className="pb-6"><SheetTitle className="font-heading text-xl tracking-wide">Правовая информация</SheetTitle></SheetHeader>
      <Accordion type="single" collapsible defaultValue={defaultSection} className="space-y-1">
        {legalSections.map((section) => <AccordionItem key={section.id} value={section.id} className="border-b border-border/50 last:border-0">
          <AccordionTrigger className="py-4 text-sm font-medium hover:no-underline">{section.title}</AccordionTrigger>
          <AccordionContent className="pb-5 pt-1">{section.content}</AccordionContent>
        </AccordionItem>)}
      </Accordion>
    </SheetContent>
  </Sheet>;
};

export default LegalHub;
